import { Person } from '@api/lendingAPI/CustomerStateAPIHelper';
import { FormattedName } from '@iwIntlProvider/FormattedName';
import { Text } from '@iwoca/orion-ui';
import upperFirst from 'lodash/upperFirst';
import { FormattedMessage } from 'react-intl';

import {
    TCompanyShareholdersPeopleData,
    useGetCompanyShareholdersData
} from './useGetCompanyShareholdersData';
import { TFundingRequirementsSteps } from '../../../funding/fundingSteps/orderFundingRequirements';
import { ONBOARDING_PATHS } from '../../constants';
import { CompletedStepItem } from '../onboardingChecks/onboardingStepItem/CompletedStepItem';
import { OnboardingStepItem } from '../onboardingChecks/onboardingStepItem/OnboardingStepItem';

export const AddCompanyShareholders = ({
    step
}: {
    step: TFundingRequirementsSteps[0];
}) => {
    const { company_shareholders } = useGetCompanyShareholdersData();

    if (step.status === 'COMPLETED') {
        return (
            <CompletedCompanyShareholders
                company_shareholders={company_shareholders}
            />
        );
    }

    return (
        <OnboardingStepItem
            title={
                <FormattedMessage
                    id="_.credit_card.onboarding.add_shareholders_step"
                    defaultMessage="Add your company shareholders"
                />
            }
            link={ONBOARDING_PATHS.ONBOARDING_SHAREHOLDERS}
        />
    );
};

const CompletedCompanyShareholders = ({
    company_shareholders
}: {
    company_shareholders: TCompanyShareholdersPeopleData['company_shareholders'];
}) => (
    <CompletedStepItem editLink={ONBOARDING_PATHS.ONBOARDING_SHAREHOLDERS}>
        <>
            <Text className="my-s text-m font-med text-primary-10">
                <FormattedMessage
                    id="_.credit_card.onboarding.shareholders.completed.title"
                    defaultMessage="Company shareholders"
                />
            </Text>
            {company_shareholders?.map((person: Person, index: number) => (
                <Text
                    key={index}
                    className="text-xs font-med text-structure-40"
                >
                    <div className="flex flex-row gap-xs">
                        <Text className="text-xs font-med text-structure-40">
                            {upperFirst(person.title)}
                        </Text>
                        <FormattedName
                            firstName={person.firstName}
                            lastName={person.lastName}
                        />
                    </div>
                </Text>
            ))}
        </>
    </CompletedStepItem>
);
